const TYPES = [
  'REQUEST',
  'COMPLETE',
  'SUCCESS',
  'FAILURE',
  'CANCEL',
  'RESET',
  'REFETCH',
];

const makeActionTypes = (base) => {
  const ref = {};

  TYPES.forEach((type) => {
    ref[type] = `${base}_${type}`;
  });

  return ref;
};

export const APP = {
  SHOW_LOADING: 'APP.SHOW_LOADING',
  HIDE_LOADING: 'APP.HIDE_LOADING',
  NOTIFICATION: {
    SHOW: 'APP.NOTIFICATION.SHOW',
    CLOSE: 'APP.NOTIFICATION.HIDE',
    UPDATE: 'APP.NOTIFICATION.UPDATE',
  },
  TOGGLE_CONTROLS: 'APP.UI.TOGGLE_CONTROLS',
  TOGGLE_SUPERBAR: 'APP.UI.TOGGLE_SUPERBAR',
  ERROR: 'APP.ERROR',
};

export const AUTH = {
  SIGNIN: {
    ...makeActionTypes('AUTH.SIGNIN'),
    ACCOUNT_INVALID: 'AUTH.SIGNIN.ACCOUNT_INVALID',
  },
  SIGNOUT: 'AUTH.SIGNOUT',
  GET_USER: 'AUTH.GET_USER',
  FAIL_AUTHENTICATE: 'AUTH.FAIL_AUTHENTICATE',
};

export const RESOURCES = {
  FETCH: makeActionTypes('RESOURCES.FETCH'),
  FETCH_SIMPLE: makeActionTypes('RESOURCES.FETCH_SIMPLE'),
  REFETCH: makeActionTypes('RESOURCES.REFETCH'),
  TASKS_SUMMARY: makeActionTypes('RESOURCES.TASKS_SUMMARY'),
  SAVE: makeActionTypes('RESOURCES.SAVE'),
  REMOVE: makeActionTypes('RESOURCES.REMOVE'),
  REMOVE_ALL: makeActionTypes('RESOURCES.REMOVE_ALL'),
  UPDATE_DATA: 'RESOURCES.UPDATE_DATA',
  ADD_DATA: 'RESOURCES.ADD_DATA',
  REMOVE_DATA: 'RESOURCES.REMOVE_DATA',
  FILTERS: {
    CLEAR: 'RESOURCES.FILTERS.CLEAR',
  },
  TASKS_CSV: makeActionTypes('RESOURCES.TASKS_CSV'),
};

export const REPORTS = {
  FETCH: makeActionTypes('REPORTS.FETCH'),
  REFETCH: makeActionTypes('REPORTS.REFETCH'),
  UPDATE: makeActionTypes('REPORTS.UPDATE'),
  SUMMARY: makeActionTypes('REPORTS.SUMMARY'),
  ADD_DATA: 'REPORTS.ADD_DATA',
  UPDATE_DATA: 'REPORTS.UPDATE_DATA',
  FILTERS: {
    CLEAR: 'REPORTS.FILTERS.CLEAR',
  },
};

export const LIST = {
  UPDATE_ITEMS: 'LIST.UPDATE_ITEMS',
};


export const SCHEDULE_DATE = {
  SAVE_DATE: makeActionTypes('SCHEDULE_DATE.SAVE_DATE'),
  LOAD_SAVED_DATE: makeActionTypes('SCHEDULE_DATE.LOAD_SAVED_DATE'),
};



// WEBPACK FOOTER //
// ./src/store/constants.js